import React, { useContext, useEffect, useState } from 'react';

import { PatientEncounterReviewApi } from '../../../../../../api';
import { ReviewContext } from '../ReviewContext';

import ReviewLogHistory from './ReviewLogHistory/ReviewLogHistory';

import './ReviewControl.scss';

export default function ReviewControl() {
  const { ssuPatientId, patientEncounterId } = useContext(ReviewContext);

  const [reviewHistory, setReviewHistory] = useState([]);

  useEffect(
    function() {
      PatientEncounterReviewApi.getCraHistory(ssuPatientId, patientEncounterId).then(({ data }) => {
        setReviewHistory(data.items);
      });
    },
    [ssuPatientId, patientEncounterId]
  );

  return (
    <div className="eds-review-control">
      <div className="eds-review-history">
        <ReviewLogHistory reviewHistory={reviewHistory} />
      </div>
    </div>
  );
}
